// TODO this is more suitable to be in graph leaving it here temporary
import {
  Maybe,
  OnlineAuctionSegmentBid,
  OnlineAuctionSegmentBidProposedTermsDocument,
  SealedBidInput,
} from '@adc/sdk/types'
import * as graph from '@adc/sdk'
import * as formatters from './formatters'
import _ from 'lodash'

export const paymentTypeOptions = [
  {
    value: graph.enums.FinanceType.Cash,
    text: formatters.formatEnum(graph.enums.ListingFinanceType.Cash) as string,
  },
  {
    value: graph.enums.FinanceType.Conventional,
    text: formatters.formatEnum(graph.enums.FinanceType.Conventional) as string,
  },
  {
    value: graph.enums.FinanceType.Fha,
    text: graph.enums.FinanceType.Fha,
  },
  {
    value: graph.enums.FinanceType.Va,
    text: graph.enums.FinanceType.Va,
  },
  {
    value: graph.enums.FinanceType.Usda,
    text: graph.enums.FinanceType.Usda,
  },
  {
    value: graph.enums.FinanceType.RehabLoan,
    text: formatters.formatEnum(graph.enums.FinanceType.RehabLoan) as string,
  },
  {
    value: graph.enums.FinanceType.LineOfCredit,
    text: 'Line of Credit',
  },
  {
    value: graph.enums.FinanceType.HardMoneyLoan,
    text: formatters.formatEnum(
      graph.enums.FinanceType.HardMoneyLoan
    ) as string,
  },
  {
    value: graph.enums.FinanceType.Other,
    text: formatters.formatEnum(graph.enums.FinanceType.Other) as string,
  },
]

export const sellerBuyerOptions = [
  {
    value: graph.enums.CommissionPayerType.Seller,
    text: formatters.formatEnum(graph.enums.CommissionPayerType.Seller),
  },
  {
    value: graph.enums.CommissionPayerType.Buyer,
    text: formatters.formatEnum(graph.enums.CommissionPayerType.Buyer),
  },
]

export const getOfferTermsCalculations = (
  bid?: Maybe<OnlineAuctionSegmentBid>
) => {
  const terms = bid?.terms

  const offerAmount = terms?.offer_amount || 0
  const purchasePrice = offerAmount + (terms?.buyers_premium_amount || 0)

  const buyerCommissions = terms?.commission?.filter(
    c => c.paid_by === graph.enums.CommissionPayerType.Buyer
  )

  const sellerCommissions = terms?.commission?.filter(
    c => c.paid_by === graph.enums.CommissionPayerType.Seller
  )

  const sellerConcessionAmount = terms?.seller_concession_amount || 0
  const buyerCommissionsAmount =
    buyerCommissions?.reduce((a, c) => a + c.agent_commission_amount, 0) || 0
  const sellerCommissionsAmount =
    sellerCommissions?.reduce((a, c) => a + c.agent_commission_amount, 0) || 0
  const afterAdjustments =
    offerAmount - sellerCommissionsAmount - sellerConcessionAmount

  return {
    offerAmount,
    purchasePrice,
    buyerCommissionsAmount,
    sellerCommissionsAmount,
    sellerConcessionAmount,
    afterAdjustments,
  }
}

export const getOfferValues = (
  bid?: Maybe<OnlineAuctionSegmentBid>
): SealedBidInput => {
  return {
    listing_id: bid?.listing_id ?? '',
    bidder_party_id: bid?.bidder_party_id ?? '',
    buyers_premium_amount: bid?.terms?.buyers_premium_amount,
    offeror_type: bid?.terms?.offeror_type ?? graph.enums.OfferorType.Buyer,
    bid_type:
      bid?.type ?? graph.enums.OnlineAuctionSegmentBidType.TraditionalOffer,
    is_agent_included: bid?.terms?.is_agent_included ?? false,
    offer_amount: bid?.terms?.offer_amount as number,
    down_payment_amount: bid?.terms?.down_payment_amount,
    earnest_money_deposit_amount: bid?.terms?.earnest_money_deposit_amount,
    payment_type:
      bid?.terms?.payment_type ?? graph.enums.FinanceType.Conventional,
    option_period_duration: bid?.terms?.option_period_duration,
    option_period_cost_amount: bid?.terms?.option_period_cost_amount,
    inspection_contingency_period_duration:
      bid?.terms?.inspection_contingency_period_duration,
    close_escrow_duration: bid?.terms?.close_escrow_duration as number,
    financing_contingency_duration:
      bid?.terms?.financing_contingency_duration ?? null,
    appraisal_contingency_duration:
      bid?.terms?.appraisal_contingency_duration ?? null,
    leaseback_duration: bid?.terms?.leaseback_duration,
    leaseback_amount: bid?.terms?.leaseback_amount,
    seller_concession_amount: bid?.terms?.seller_concession_amount,
    additional_notes: bid?.terms?.notes?.additional_notes,
    commission: bid?.terms?.commission?.[0]
      ? [
          {
            paid_by: bid?.terms?.commission?.[0]?.paid_by,
            agent_commission_amount:
              bid?.terms?.commission?.[0]?.agent_commission_amount,
          },
        ]
      : [],
    documents: _.map(
      bid?.terms?.documents,
      (doc: OnlineAuctionSegmentBidProposedTermsDocument) => ({
        document_id: doc.document_id,
        document_purpose_type: doc.document_purpose_type,
      })
    ),
  }
}
